export const environment = {
  production: false,
  name: 'dev',
  enUrl: 'https://bmo-smartapp-user-guide-dev.paralucent-apps.com',
  frUrl: null as string | null,
  frHostname: null as string | null,
  googleAnalyticsId: null as string | null,
};
